import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

export enum RequestStatus {
	NEW = 1,
	PROCESSING = 2,
	ACCEPTED = 3,
	REJECTED = 4,
	PAYMENT = 5,
	DONE = 6,
	DELETED = 7,
	FAILED = 8,
	REFUND = 9,
	Paying = 10
}


export namespace RequestStatus {

	export function getTitle(type: RequestStatus): string {
		return Object.keys(RequestStatus).find(key => RequestStatus[key] === type);
	}

}


@Pipe({
	name: 'requestStatusText',
	standalone: true
})
export class RequestStatusTextPipe implements PipeTransform {

	constructor(private translateService: TranslateService) {
	}

	RequestStatus = RequestStatus;
	translatedText: string;

	transform(value: RequestStatus): any {
		this.getTranslate(
			this.RequestStatus.getTitle(value)
		);

		return this.translatedText;
	}

	async getTranslate(text: string) {
		text = 'ENUM.REQUEST_STATUS.' + text;
		const m = await this.translateService.get(text).subscribe(
			res => {
				this.translatedText = res;
			}
		);
	}
}

